import React from 'react'
import { Banner } from '../Banner'
import { CategoriesBannerProps } from './categoriesBanner.props'

export const CategoriesBanner = ({ data }: CategoriesBannerProps) => {
  return (
    <div className="container mt-4 pt-lg-4">
      <div className="row g-2 g-lg-4">
        {data.map((banner, index) => (
          <div key={`Banner__${index}`} className="col-6 col-lg-3">
            <Banner {...banner} />
          </div>
        ))}
      </div>
    </div>
  )
}
